import { PUPPY_TRAINING_PROGRAM_LANDING } from 'dpl/shared/constants/urls';

export const FEE_LONG_DESCRIPTION = `
This fee helps us protect your payment, provide lifetime support to you and your dog, and more.
`;

export const PAYMENT_VALUES = [
  {
    title: 'Safe, Secure, & Legal',
    description:
      'Your payments are 100% protected with lifelong support on the only payment platform that supports animal sales'
  },
  {
    title: 'Support our Mission',
    description:
      'Paying on Good Dog helps us pursue our mission of supporting ethical breeders and ensuring the health of our dogs'
  },
  {
    title: 'Free Resources',
    description:
      'Get tips, tricks, and techniques to help you raise your new pup with',
    url: PUPPY_TRAINING_PROGRAM_LANDING,
    urlText: 'Puppy College & Coaching'
  }
];

export const PAYMENT_TIER_TYPE = {
  PROTECTED: 'protected',
  BASIC: 'basic'
};

export const PAYMENT_METHODS = {
  CARD: 'card',
  ACH_DEBIT: 'ach_debit'
};

export const SELECT_PAYMENT_MODAL_NAME = {
  LEARN_MORE: 'learnMore',
  PAYMENT_PROTECTION: 'paymentProtection'
};

export const SUBMIT_PAYMENT_LABEL = 'Pay now';
